import { AHText, Box } from "arkh";
import React from "react";
import { OutlinedHeaderButton } from "../../../../RoutineOccasion/RoutineOccasionScreen/OutlinedHeaderButton";

function WebModalHeaderTitle(props: { children: React.ReactNode }) {
  return (
    <Box>
      <AHText
        spaceRight="medium"
        type="subtitle"
        color="text-secondary"
        ellipsizeMode="tail"
        numberOfLines={1}
        style={{ flexShrink: 1 }}
      >
        {props.children}
      </AHText>
    </Box>
  );
}

function WebModalHeaderCloseButton(props: { onPress: () => void }) {
  return (
    <OutlinedHeaderButton
      spaceLeft="medium"
      tintColor="text-secondary"
      icon="clear"
      onPress={props.onPress}
    />
  );
}

const MIN_HEIGHT = 50;
export function WebModalHeader(props: {
  title?: React.ReactNode;
  close?: React.ReactNode;
}) {
  return (
    <Box
      color="surface"
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        minHeight: MIN_HEIGHT,
        borderBottomWidth: 1,
      }}
      borderColor="border-primary"
      space="medium"
    >
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        {props.title}
      </Box>
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        {props.close}
      </Box>
    </Box>
  );
}

WebModalHeader.CloseButton = WebModalHeaderCloseButton;
WebModalHeader.Title = WebModalHeaderTitle;
